import { axiosInstance } from '@/axiosInstance';
import { formatedDateToBack } from '@/helpers/date';
import { defineStore } from 'pinia';
import { CtlTypes } from '@adcleek/db-types';
import { useAccessDataStore, useAccessOperationsStore, useGlobalStore } from './storeIndex';

export const usePurchaseCampaignsStore = defineStore('usePurchaseCampaignsStore', {
    state: () => ({
        quotation: [] as {
            quotationCode: string;
            billCode: string;
            paymentCode: string;
            couponCode: string[];
            parentCampaignCode: string;
            childCampaignCode: string[];
        }[],
    }),
    getters: {},
    actions: {
        async purchaseCampaigns(token: string) {
            const accessDataStore = useAccessDataStore();
            const accessOperationsStore = useAccessOperationsStore();
            const globalStore = useGlobalStore();

            const brand = globalStore.brand;
            const mediasCode = accessDataStore.getMediasToDisplay;

            // const url = `http://localhost:3400/b_user/access-operations/purchase`;
            const url = `/users/access-operations/purchase`;
            const campaigns = [] as CtlTypes.QuotationApiCreateCampaignsCtlSub[];
            const agents = accessDataStore.selectedAgents;

            mediasCode.forEach((media: string) => {
                campaigns.push({
                    mediaCode: media,
                    amount: Math.round(accessDataStore.budget / mediasCode.length),
                    volume: Math.round(accessDataStore.impressionsCount / mediasCode.length),
                    startDate: formatedDateToBack(accessDataStore.getCampaignStartDate),
                    endDate: formatedDateToBack(accessDataStore.getCampaignEndDate),
                    creaFormat: 1,
                    sms: null,
                });
            });

            campaigns[0].amount += accessDataStore.budget % mediasCode.length;
            campaigns[0].volume += accessDataStore.impressionsCount % mediasCode.length;

            const baseData = {
                brand,
                posCode: accessOperationsStore.accessOperations.pos_code,
                campaignData: campaigns,
                token,
            };
            let purchaseData: CtlTypes.UserAccessOperationPostPurchaseCtl;
            if (agents.length) {
                const operations = [];
                const agentCodes = [];

                for (const agent of agents) {
                    operations.push({ code: agent.code, name: `operation-agent_${agent.text}` });
                    agentCodes.push(agent.code);
                }
                purchaseData = {
                    ...baseData,
                    operations,
                    zipCodes: accessDataStore.zipCodes,
                    agents: agentCodes,
                } as unknown as CtlTypes.UserAccessOperationPostAgentPurchaseCtl;
            } else {
                purchaseData = {
                    ...baseData,
                    operations: accessDataStore.selectedOperations.map((so) => ({ code: so.code, name: so.name })),
                    zoneCode: null,
                    zipCodes: accessDataStore.zipCodes,
                    agentCode: null,
                };
            }

            try {
                const res = await axiosInstance.post(url, purchaseData);
                this.quotation = res.data;
            } catch (error) {
                console.error(error);
                throw error;
            }
        },
    },
});
